// import { isAllowedWithoutCurrency, toLogin } from "./utils";

import req from "./https.js";

export const request = (method, path, data = null, needAuth = false) =>
  req(method, `${process.env.REACT_APP_API_MAIN_URL}${path}`, data, needAuth);

export const requestUser = (method, path, data = null, needAuth = false) =>
  req(method, `${process.env.REACT_APP_API_USER_URL}${path}`, data, needAuth);

export const requestUtil = (method, path, data = null, needAuth = false) =>
  req(method, `${process.env.REACT_APP_API_UTIL_URL}${path}`, data, needAuth);
